<template>
  <div id="app" slot="main">
    <slot></slot>
    <openAppModel
      v-if="!openAppModalOnSelf && !_isServer"
      v-model="isShowOpenAppModel"
      :link="toAppLink"
    />
  </div>
</template>

<style lang="scss">
#app {
  width: 100%;
  max-width: 10rem;
  margin: 0 auto;
  // overflow-x: hidden;

  &::-webkit-scrollbar {
    display: none;
  }
}
</style>

<script type="text/babel">
import baiduStat from 'lib/tools/baiduStat.js'
import openAppModel from 'app/web/component/common/openAppModel.vue'
import { addUrlParams } from 'app/frontend-lib/tools/url.js'
import { broswerLoadedToDownloadApp } from '@yxl/libs'

export default {
  props: ['description', 'keywords'],
  data() {
    return {
      isShowOpenAppModel: false,
      toAppLink: 'yixinli://open_zixun_index',
      openAppModalOnSelf: false // 通过router的meta设置当前路由是否显示默认引导APP跳转弹窗
    }
  },
  components: {
    openAppModel
  },
  computed: {
    alidebug() {
      return `!(function(c,b,d,a){c[a]||(c[a]={});c[a].config={pid:"ial18ekfch@9cd2d5f0cda67d7",appType:"web",imgUrl:"https://arms-retcode.aliyuncs.com/r.png?",disableHook:true,sendResource:true,enableSPA:true};
with(b)with(body)with(insertBefore(createElement("script"),firstChild))setAttribute("crossorigin","",src=d)
})(window,document,"https://retcode.alicdn.com/retcode/bl.js","__bl");`
    },

    _isServer() {
      return this.$isServer
    }
  },
  created() {
    const { openAppModalOnSelf, hideNavigationBar, pageName } = this.$route.meta
    this.openAppModalOnSelf = openAppModalOnSelf
    if (!this.$isServer && pageName !== '咨询主页V5') {
      let href = window.location.href.replace('http://', 'https://')
      if (hideNavigationBar !== false) {
        href = addUrlParams({
          url: href,
          params: {
            hideNavigationBar: 1
          }
        })
      }
      this.toAppLink = href
    }

    if (!this.$isServer && this.$route.query.from === 'message') {
      broswerLoadedToDownloadApp()
    }
  },
  mounted() {
    try {
      baiduStat()
    } catch (e) {
      console.log(e)
    }
  }
}
</script>
